// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 服务操作类型 枚举类
 * 服务操作类型
 */
export enum EnumServiceActionType {
  /** 商业逻辑 : 商业逻辑 */
  BusinessLogic = 1,
  /** API接口 : API接口 */
  API = 2
}

/**
 * 服务操作类型 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumServiceActionTypeMD {
  private static items = [
    new EnumItemMD('BusinessLogic', 1, '商业逻辑', '商业逻辑'),
    new EnumItemMD('API', 2, 'API接口', 'API接口')
  ];

  static getItem(enumItem: EnumServiceActionType) {
    return this.items.find(item => item.name === EnumServiceActionType[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
